import { IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { chevronForwardOutline, heart } from 'ionicons/icons';
import { ContentInfo, ContentUpdateInt } from '../data/item';
import React, { Component }  from 'react';

import NServer, { UIElement } from "../components/NServer";
import { showAlert } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import '../pages/Main.css'; 

  
const ReactionBar : React.FC<ContentUpdateInt> = ({ content, index, onUpdate }) => {
    
    const router = useIonRouter();

    const sendReactComment = async (msg : string) => {
        
        // update locally
        content.react_comments = [];
        await onUpdate(index, content, true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: content.id,
            msg: msg
        }

		var server = new NServer();
        await server.sendForm("nc_send_react", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // refresh UI
            onUpdate(index, content, false);
        }
    } 

    if (content.react_comments == null)
        return (<div/>);
    if (content.react_comments.length == 0)
        return (<div/>);

    return (
        <IonItem className="react-content" lines="full">
            <div className="react-bar">
            {
                content.react_comments.map( (m, index) => 
                <IonChip key={index} onClick={ ()=> sendReactComment(m) }><IonLabel>{ m }</IonLabel></IonChip>
                )
            }
           </div>
        </IonItem>
    );
};
  
export default ReactionBar;